<template>
    <div class="about_us">
      <div class="top">
        <div class="top__large">关于我们</div>
        <div class="top__small">ABOUT US</div>
      </div>
      <div class="content">
        <div class="title" id="profile">粤桥工科简介</div>
        <div class="sub-title">Company Profile</div>
        <div class="image">
          <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_company.png" width="100%" />
        </div>
  
        <div class="title" id="introduce">团队介绍</div>
        <div class="sub-title">Team Introduce</div>
        <div class="image">
          <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_team1.png" width="100%" alt="" style="margin-bottom: 0.625rem;">
        </div>
  
        <div class="title" id="progress">发展历程</div>
        <div class="sub-title">Development Progress</div>
        <div class="image">
          <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_progress.png" width="100%" />
        </div>
  
        <div class="title" id="enterprise">合作企业</div>
        <div class="sub-title">Cooperative Enterprise</div>
        <div class="image">
          <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_enterprise.png" width="100%" />
        </div>
  
        <div class="title" id="honors">荣誉成果</div>
        <div class="sub-title">Honors and Achievements</div>
        <div class="image">
          <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_honor1.png" width="100%"/>
        </div>
  
        <div class="title" id="contact">联系我们</div>
        <div class="sub-title">Contact Us</div>
        <div class="image">
          <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/map.png"/>
          <div class="contact">
            <div><Icon type="md-pin" color="red" style="margin-right: 0.25rem;"/><b>地址: </b><span style="display: inline-block;">广州市天河区长福路207号首层s26单元</span><span style="display:block;margin-left: 1.2rem;">广州市黄埔区中新智慧一街7号a-1栋1008单元</span><span style="display:block;margin-left: 1.2rem;">广州市天河区五山路381号</span></div>
            <div><img src="../../assets/images/微信.png" alt="" style="display:inline-block;vertical-align: middle;margin-right:0.25rem;width:0.25rem;"><b>微信: </b><img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/wechatQRcode2.jpg" alt="" style="width:1.875rem;display:inline-block;margin-left:0.125rem;vertical-align: top;"><span>(陈小姐)</span></div>
            <div><Icon type="md-mail" color="orange" style="margin-right:0.25rem;"/><b style="margin-right:0.125rem;">邮箱: </b>gzyqgc@163.com</div>
          </div>
        </div>
        <Anchor show-ink>
          <AnchorLink href="#profile" title="粤桥工科简介" />
          <AnchorLink href="#introduce" title="团队介绍" />
          <AnchorLink href="#progress" title="发展历程" />
          <AnchorLink href="#enterprise" title="合作企业" />
          <AnchorLink href="#honors" title="荣誉成果" />
          <AnchorLink href="#contact" title="联系我们" />
        </Anchor>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: 'newabout_us',
    data() {
      return {
      }
    },
    created() {
      this.$emit('changeProduce','newabout_us')
    },
    mounted () {
      if (this.$route.params.scroll) {
        const value = this.$route.params.scroll
        const srcollTab = document.getElementById(value)
        if (srcollTab) {
          srcollTab.scrollIntoView()
        }
      }
    }
  }
  </script>
  <style lang="less" scoped>
  .about_us {
    .top {
      width: 100%;
      height: 3.5rem;//280px
      background: url('https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_banner.png') center center no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      font-weight: bold;
      color: #fff;
      padding-left: 2.625rem;//210px
      &__large {
        font-size: 0.5rem;
        line-height: 1.5em;
      }
      &__small {
        font-size: 0.35rem;
        line-height: 1.2em;
        word-spacing: 0.1875rem;
      }
    }
    .content {
      width: 80%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 0.8rem;
      .title {
        margin: 0.6rem 0 0;
        position: relative;
        font-size: 0.35rem;
        line-height: 1.5em;
        font-weight: bold;
        color: #000;
      }
      .title::after {
        content: "";
        position: absolute;
        bottom: -0.1rem;
        left: 50%;
        transform: translateX(-50%);
        width: 2em;
        height: 0.1rem;
        background-color: #2d8cf0;
      }
      .sub-title {
        margin: 0.125rem 0 0.4rem;
        font-size: 0.22rem;
        line-height: 1.5em;
        color: #6d7278;
      }
      .image {
        margin-bottom: 0.4rem;
        width: 80%;
        // height: 450px;
        img{
          display: block;
          margin: 0 auto;
          width: 100%;
        }
        .contact{
          width: 90%;
          margin: 0.25rem auto 0;
  
          div{
            display: block;
            width: 100%;
            font-size: 0.21rem;
            line-height: 2em;
            margin: 0.125rem 0;
            span{
              margin: 0 0.25rem 0 0.125rem;
            }
          }
        }
      }
  
      .teamBox{
        display: block;
        width: 100%;
        
        img{
          display: block;
          width: 100%;
        }
      }
    }
  }
  /deep/ .ivu-anchor{
    position: fixed;
    right: 0.125rem;
    top: 50%;
    font-size: 0.2rem;
  }
  /deep/ .ivu-anchor-ink-ball{
    width: 0.1rem;
    height: 0.1rem;
  }
  /deep/ .ivu-anchor-link{
    padding: 0.1rem 0 0.1rem 0.2rem;
  }
  </style>
  